import CertificateEntity from './CertificateEntity';
import CertificateListItem, { CERTIFICATE_QUERY_PARAM } from './CertificateListItem';
import ProfileList from '../common/ProfileList';
import { FreelancerContext } from '../FreelancerEntity';
import { useContext } from 'react';

const CertificateList = () => {
  const { user } = useContext(FreelancerContext);

  return (
    <ProfileList
      list={user.freelancerProfile.certificates || []}
      title={'Certificates'}
      emptyListText={'Not uploaded'}
      ListItemComponent={CertificateListItem}
      entityQueryParam={CERTIFICATE_QUERY_PARAM}
      EntityComponent={CertificateEntity}
    />
  );
};

export default CertificateList;